import { Component, Input } from '@angular/core';
import { TwoWayBoundComponent } from '@app/shared/components/base/two-way-bound.component';
import { Bank } from '@app/shared/models/bank';

@Component({
    selector: 'banks-twb',
    templateUrl: './banks.component.html',
    styleUrls: ['./banks.component.scss']
})
export class BanksComponent extends TwoWayBoundComponent<Bank[]> {

    @Input()
    public multi: boolean;

    @Input()
    public bankCol: string;

    get banks(): Bank[] {
        return this.bananaBox;
    }

    constructor() {
        super();
    }

    public addBank(): void {
        this.banks.unshift(new Bank({ name: '', iban: '', bic: '' }));
    }

    public removeBank(idx: number): void {
        this.banks.splice(idx, 1);
        this.onChange();
    }
}
